import { Modal } from "components/modal/modal";
import React, { useEffect } from "react";
import Image from "next/legacy/image";
import {
  ClassJoinModalContainer,
  ClassJoinModalDesc,
  ClassJoinModalHeading,
  ClassJoinModalImageWrapper
} from "./class-join-modal.styles";
import trackEvent from "services/mixpanel/mixpanel";
import { kelasLiveEvents } from "services/mixpanel/kelas-live-events";
import { IPrimaryUser } from "services/api/api.types";
import { SubscriptionType } from "services/api/sessions/sessionService.types";

const ClassJoinModal: React.FC<{
  primaryUser: IPrimaryUser;
  subscriptionType: SubscriptionType;
}> = ({ primaryUser, subscriptionType }) => {
  useEffect(() => {
    trackEvent({
      eventName: kelasLiveEvents.liveClassLoadingModalViewed,
      payload: {
        userType: subscriptionType,
        grade: primaryUser.grade,
        curriculum: primaryUser.curriculum,
        stream: primaryUser.stream
      }
    });
  }, []);

  return (
    <Modal isOpen={true} onClose={() => null}>
      <ClassJoinModalContainer>
        <ClassJoinModalImageWrapper>
          <Image
            src="/assets/kelas-live/live-class-loading.svg"
            alt="Joining the class"
            layout="intrinsic"
            width={260}
            height={260}
          />
        </ClassJoinModalImageWrapper>
        <ClassJoinModalHeading>Bentar lagi kelas mulai..</ClassJoinModalHeading>
        <ClassJoinModalDesc>
          Tunggu sebentar, ya. Siap-siap kita bawa ke Zoom 🚀
        </ClassJoinModalDesc>
      </ClassJoinModalContainer>
    </Modal>
  );
};

export { ClassJoinModal };
